// @ts-nocheck
import React from 'react'
import * as R from 'ramda'
import cx from 'classnames'
// import { Debug } from 'components/debug.js'
import moment from 'moment'
import { useSelector } from 'react-redux'
import Icon from 'components/common/Icon'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import HelpTip from 'components/common/HelpTip'
import { Textarea } from 'components/common/FormFields/Textarea/Textarea'

const ErrorMessage = ({ children }) => (
  <div className="ErrorMessage">
    <Icon name="alert" /> {children}
  </div>
)

const ModelSelect = ({ target, ...props }) => {
  target.useModel()
  const options = useSelector(target.getOptions) || []
  return <SelectWidget {...props} options={options} />
}

const eventHandlerFactory = R.curryN(3, (callBack, props, data) => {
  const newValue = props.isMulti
    ? R.ifElse(R.is(Array), R.pluck('value'), R.always([]))(data)
    : R.prop('value', data)
  const fakeEvent = { target: { value: newValue || props.defaultValue } }
  callBack(fakeEvent)
})

const SelectWidget = ({
  onBlur,
  onChange,
  value,
  options,
  creatable = false,
  ...props
}) => {
  const findValue = v => R.find(R.propEq('value', v), options)
  const selected = props.isMulti ? R.map(findValue, value) : findValue(value)

  const selectProps = {
    ...props,
    'aria-label': props.name,
    options,
    value: !R.isNil(selected) ? selected : null,
    onBlur: onBlur && eventHandlerFactory(onBlur, props),
    onChange: onChange && eventHandlerFactory(onChange, props),
    classNamePrefix: 'react-select',
  }
  return creatable ? (
    <CreatableSelect {...selectProps} />
  ) : (
    <Select {...selectProps} />
  )
}

const Checkbox = ({ value, onChange, ...props }) => (
  // use checked boolean as value for onChange handler to work properly with
  // ModelFormField
  <input
    type="checkbox"
    checked={value}
    onChange={ev => onChange({ target: { value: ev.target.checked } })}
    {...props}
  />
)

const DateField = ({ value, ...props }) => (
  <input
    type="date"
    value={value && moment(value).format('YYYY-MM-DD')}
    {...props}
  />
)

const DateTimeField = ({ value, ...props }) => (
  <input
    type="datetime-local"
    value={value && moment(value).format('YYYY-MM-DDTHH:mm')}
    {...props}
  />
)

const Widget = ({ type, ...props }) => {
  if (type === 'modelselect') return <ModelSelect {...props} />
  if (type === 'select') return <SelectWidget {...props} />
  if (type === 'textarea') return <Textarea {...props} />
  if (type === 'checkbox') return <Checkbox {...props} />
  if (type === 'date') return <DateField {...props} />
  if (type === 'datetime') return <DateTimeField {...props} />
  return <input type={type} {...props} />
}

export const FormField = ({
  className,
  name,
  label,
  placeholder = label,
  helptext,
  type = 'text',
  errors = [],
  onChange,
  onBlur,
  focus = false,
  hover = false,
  style,
  ...props
}) => {
  const error = errors.length !== 0
  const [focused, setFocus] = React.useState(focus)
  return (
    <label
      htmlFor={name}
      style={style}
      className={cx('FormField', { [className]: Boolean(className) })}
    >
      {label && <span className="label">{label}</span>}
      {helptext && (
        <HelpTip>
          {helptext.split(/\n/g).map((txt, idx) => (
            <p key={idx}>{txt}</p>
          ))}
        </HelpTip>
      )}
      <Widget
        id={name}
        name={name}
        className={cx({ focus, hover, error })}
        noValidate
        type={type}
        onChange={onChange}
        onFocus={ev => setFocus(true)}
        onBlur={ev => {
          setFocus(false)
          onBlur && onBlur(ev)
        }}
        placeholder={focused ? placeholder : label || placeholder}
        {...props}
      />
      {errors.map(msg => (
        <ErrorMessage key={msg} children={msg} />
      ))}
    </label>
  )
}

export default FormField
